export interface SaRouteActivityMeta {
  pageTitle: string;
  moduleName: string;
}

const EXACT_ROUTES: Record<string, SaRouteActivityMeta> = {
  "/dashboard": {
    pageTitle: "Dashboard",
    moduleName: "Super Admin dashboard overview",
  },
  "/albums": {
    pageTitle: "Albums",
    moduleName: "Music Group album management section",
  },
  "/artists": {
    pageTitle: "Artists",
    moduleName: "Music Group artist management section",
  },
  "/songs": {
    pageTitle: "Songs",
    moduleName: "Music Group song library section",
  },
  "/record-labels": {
    pageTitle: "Record Labels",
    moduleName: "Music Group record label section",
  },
  "/genres": {
    pageTitle: "Genres",
    moduleName: "Music Group genre catalog section",
  },
  "/channel-admin": {
    pageTitle: "Channel Admin",
    moduleName: "Music Group channel administration section",
  },
  "/music-channel-programming": {
    pageTitle: "Channel Dashboard",
    moduleName: "Music Group channel programming section",
  },
  "/channel-programming-overview": {
    pageTitle: "Channel Programming Overview",
    moduleName: "Music Group channel programming overview section",
  },
  "/live-plays-tracker": {
    pageTitle: "Live Plays Tracker",
    moduleName: "Music Group live plays tracking section",
  },
  "/uploader": {
    pageTitle: "Uploader",
    moduleName: "Music Group uploader section",
  },
  "/uploader-history": {
    pageTitle: "Uploader History",
    moduleName: "Music Group upload history section",
  },
  "/processing-jobs": {
    pageTitle: "Song Processing",
    moduleName: "Music Group song processing section",
  },
  "/music-upload-reviews": {
    pageTitle: "Song Intake",
    moduleName: "Music Group Song Intake section",
  },
  "/accounts": {
    pageTitle: "Accounts",
    moduleName: "Clients account management section",
  },
  "/brands": {
    pageTitle: "Brands",
    moduleName: "Clients brand management section",
  },
  "/devices": {
    pageTitle: "Devices",
    moduleName: "Clients device management section",
  },
  "/employees": {
    pageTitle: "Employees",
    moduleName: "Admin employee management section",
  },
  "/employee-roles": {
    pageTitle: "Employee Roles",
    moduleName: "Admin employee role management section",
  },
  "/employee-departments": {
    pageTitle: "Employee Departments",
    moduleName: "Admin employee department management section",
  },
  "/activity-history": {
    pageTitle: "Activity History",
    moduleName: "Admin activity history section",
  },
  "/music-vendors": {
    pageTitle: "Music Vendors",
    moduleName: "Vendors music vendor management section",
  },
  "/inventory-products": {
    pageTitle: "Inventory Products",
    moduleName: "Inventory product management section",
  },
};

function titleFromSegment(segment: string): string {
  return segment
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

/** Resolve page-view metadata for a Super Admin route path. */
export function resolveSaRouteActivityMeta(pathname: string): SaRouteActivityMeta | null {
  const path = pathname.split("?")[0].split("#")[0] || "/";
  if (path === "/" || path.startsWith("/?")) {
    return null;
  }

  const exact = EXACT_ROUTES[path];
  if (exact) return exact;

  const segments = path.split("/").filter(Boolean);
  if (segments.length === 0) return null;

  const pageTitle = titleFromSegment(segments[segments.length - 1]);
  const section = titleFromSegment(segments[0]);
  return {
    pageTitle,
    moduleName: `${section} ${pageTitle.toLowerCase()} section`,
  };
}
